<template>
  <!-- Menu Print -->
  <div v-if="excel.items.length > 0 || pdf.active" class="btn-print">
    <v-menu bottom offset-y>
      <template #activator="{ on, attrs }">
        <v-img
          width="25px"
          height="25px"
          contain
          src="@/assets/img/navbar_icons/printer-icon.svg"
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <div class="modal-print elevation-2">
        <v-row>
          <v-col>
            <p class="mb-2"><b>Descargar en:</b></p>
            <v-btn-toggle>
              <v-btn
                v-if="excel.items.length > 0"
                class="btns-print-group"
                outlined
                color="grey"
              >
                <vue-json-to-csv
                  :show-labels="excel.showLabels"
                  :json-data="excel.items"
                  :csv-title="nameExcel()"
                >
                  Excel
                  <v-icon color="green" class="ml-2" small
                    >mdi mdi-file-download</v-icon
                  >
                </vue-json-to-csv>
              </v-btn>
              <v-btn
                class="btns-print-group"
                outlined
                color="grey"
                @click="generarPDFWithDelay"
              >
                PDF
                <v-icon color="red" class="ml-2" small
                  >mdi mdi-file-download</v-icon
                >
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </div>
    </v-menu>
  </div>
  <!-- End Menu Print -->
</template>

<script>
  /* eslint-disable */
  import { mapGetters, mapActions } from 'vuex';
  import VueJsonToCsv from 'vue-json-to-csv';
  import html2pdf from 'html2pdf.js';
  import moment from 'moment';
  export default {
    components: { VueJsonToCsv },
    computed: {
      ...mapGetters({
        excel: 'printer/getExcel',
        pdf: 'printer/getPDF',
      }),
    },
    watch: {
      $route() {
        this.resetPrinter();
      },
    },
    data() {
      return {
        today: moment().format('YYYY/MM/DD'),
      };
    },
    mounted() {},
    methods: {
      ...mapActions({
        resetPrinter: 'printer/resetPrinter',
      }),
      generarPDFWithDelay() {
        // Agrega un retraso de 1 segundo (1000 milisegundos) antes de ejecutar la función
        setTimeout(() => {
          this.generatePDF();
        }, 1000);
      },
      generatePDF() {
        const htmlElement = document.querySelector('html');
        const disabledPdfElement = document.querySelector(
          `.${this.pdf.disabledClass}`
        );
        if (disabledPdfElement) {
          disabledPdfElement.style.display = 'none';
        }

        const pdfOption = {
          margin: 1,
          filename: this.namePDF(),
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: window.innerWidth <= 768 ? 1 : 1.8 },
          jsPDF: { unit: 'px', format: [1920, document.body.scrollHeight] },
        };

        let viewportMeta = htmlElement.querySelector('meta[name="viewport"]');
        let originalViewportContent = viewportMeta.getAttribute('content');

        viewportMeta.setAttribute('content', 'width=1148');
        html2pdf(htmlElement, pdfOption).then(() => {
          viewportMeta.setAttribute('content', originalViewportContent);
          if (disabledPdfElement) {
            disabledPdfElement.style.display = 'block';
          }
        });
      },
      namePDF() {
        return this.pdf.name != null
          ? `${this.excel.name}-${this.today}`
          : `${this.$route.name}-${this.today}`;
      },
      nameExcel() {
        return this.excel.name != null
          ? `${this.excel.name}-${this.today}`
          : `${this.$route.name}-${this.today}`;
      },
    },
  };
</script>

<style scoped>
  .v-menu__content {
    overflow-y: inherit !important;
    overflow-x: inherit !important;
    contain: inherit !important;
    min-width: auto !important;
  }
  .btn-print .btn-print-icon {
    font-size: 30px !important;
    color: #fff !important;
  }
  .modal-print {
    right: -30px !important;
    min-width: 200px;
  }
  .btns-print-group {
    font-size: 12px !important;
    height: 40px !important;
    width: 100px;
  }
</style>
